
import React from 'react';
import { observer } from 'mobx-react';
import { ImgHome } from '../components/Images/ImgHome';

@observer
export default class Page403 extends React.Component {

  componentDidMount(){
    setTimeout(() => {
      window.location.href = '/';
    }, 5000);
  }

  render(){
    const currentUrl = window.location.href;

    return (
      <div className="error-page">
        <div className="error-card">
          <img src="/img/fly.apng" className="top-image" alt="" />
          <h1>Oops!</h1>
          <h2>403 Access Denied</h2>
          <div className="error-details">
            Sorry, but the url requested is not available for you<br/>
            (You are trying to access page &quot;<b>{currentUrl}</b>&quot;)
          </div>
          <div className="error-actions">
            <a href="/" className="btn btn-primary">
              <ImgHome size={16} />
              &nbsp;Take Me Home
            </a>
          </div>
        </div>
      </div>
    );
  }
}